/**
 * Public LegalDocument download / meta URLs (G8 / LEG-D04).
 * Path SSOT matches backend `PUBLIC_LEGAL_DOCUMENTS_API_PREFIX`.
 */

export const PUBLIC_LEGAL_DOCUMENTS_API_PREFIX =
  '/api/v1/public/legal-documents' as const;

export type LegalDocumentPurpose = 'TERMS_OF_SERVICE' | 'PRIVACY_NOTICE';

export type PublicLegalDocumentUrlOptions = {
  readonly locale?: string;
  /** When true, append `/meta` (version / checksum metadata). */
  readonly meta?: boolean;
};

/** Relative public GET path for a legal purpose. */
export function publicLegalDocumentPath(
  purpose: LegalDocumentPurpose,
  options?: PublicLegalDocumentUrlOptions
): string {
  const suffix = options?.meta === true ? '/meta' : '';
  const path = `${PUBLIC_LEGAL_DOCUMENTS_API_PREFIX}/${purpose}${suffix}`;
  const locale = options?.locale?.trim();
  if (locale === undefined || locale.length === 0) {
    return path;
  }
  const params = new URLSearchParams({ locale });
  return `${path}?${params.toString()}`;
}

/**
 * Absolute or same-origin URL for register / account download links.
 * Empty `apiBaseUrl` → same-origin relative path (Vite/Caddy proxy).
 */
export function publicLegalDocumentUrl(
  apiBaseUrl: string,
  purpose: LegalDocumentPurpose,
  options?: PublicLegalDocumentUrlOptions
): string {
  const trimmedBase = apiBaseUrl.replace(/\/+$/, '');
  const path = publicLegalDocumentPath(purpose, options);
  return trimmedBase.length > 0 ? `${trimmedBase}${path}` : path;
}

export function termsOfServiceDocumentUrl(
  apiBaseUrl: string,
  options?: PublicLegalDocumentUrlOptions
): string {
  return publicLegalDocumentUrl(apiBaseUrl, 'TERMS_OF_SERVICE', options);
}

export function privacyNoticeDocumentUrl(
  apiBaseUrl: string,
  options?: PublicLegalDocumentUrlOptions
): string {
  return publicLegalDocumentUrl(apiBaseUrl, 'PRIVACY_NOTICE', options);
}
